var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSampleRequestNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.625 28.125C40.625 14.0625 25 3.125 25 3.125C25 3.125 9.375 14.0625 9.375 28.125C9.375 32.269 11.0212 36.2433 13.9515 39.1735C16.8817 42.1038 20.856 43.75 25 43.75C29.144 43.75 33.1183 42.1038 36.0485 39.1735C38.9788 36.2433 40.625 32.269 40.625 28.125Z",
    stroke: "#F1C24B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5859 37.347C28.4971 37.0221 30.2602 36.1118 31.6319 34.7419C33.0035 33.372 33.9159 31.61 34.2431 29.6992",
    stroke: "#F1C24B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSampleRequestNew);
export default __webpack_public_path__ + "static/media/Sample_Request_New.660fe011b372a18c544efbb237e69c07.svg";
export { ForwardRef as ReactComponent };